
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  // AI,
  // Answer,
  // AIGroup,
  Candidate,
  CandidateResult,
  // ColorQuestionAnswerResult,
  ReportShowConfigV5Item
} from "@/lib/model/exam/result";
import AiGuide from "./guide.vue"; //先copy一份再改
@Component({ components: { AiGuide } })
export default class PaperResultReport extends Vue {
  @Prop() index!: number;
  @Prop({ default: () => new Candidate() }) candidate!: Candidate;
  @Prop({ default: () => new CandidateResult() }) all!: CandidateResult;
  @Prop({ default: () => ({}) }) mindData!: any;
  @Prop({ default: () => ({}) }) pdfPsycGuide!: any;
  @Prop({ default: false }) pdfIng!: boolean;
  @Prop({ default: () => new ReportShowConfigV5Item() })
  option!: ReportShowConfigV5Item;
  connectCode = "";

  created() {
    //
  }

  //
  mounted() {
    this.connectCode = this.$route.query.connectCode as string;
    // this.isStudent = String(this.$route.query.ver || "") === "1";
  }
}
